(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sro-topbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var MOBILE_MQ = '(max-width: 749px)';

    function initRotator(root) {
      var items = root.querySelectorAll('.sro-topbar__item');
      if (!items || items.length === 0) return;

      // Single item → just show it on mobile, nothing to rotate.
      if (items.length === 1) {
        items[0].classList.add('is-active');
        return;
      }

      var interval = parseInt(root.getAttribute('data-rotate-interval'), 10);
      if (!interval || interval < 1500) interval = 4000;

      var idx = 0;
      // Align `idx` with whichever item was server-stamped as active.
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-active')) { idx = i; break; }
      }

      var timer = null;

      function show(i) {
        for (var k = 0; k < items.length; k++) {
          if (k === i) items[k].classList.add('is-active');
          else         items[k].classList.remove('is-active');
        }
      }

      function start() {
        if (timer) return;
        show(idx);
        timer = setInterval(function () {
          idx = (idx + 1) % items.length;
          show(idx);
        }, interval);
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
        // On desktop, drop .is-active from every item so the flex row
        // shows all items normally. (Our CSS only hides them on mobile,
        // so this is belt-and-suspenders for a clean transition.)
        for (var k = 0; k < items.length; k++) {
          items[k].classList.remove('is-active');
        }
      }

      var mql = window.matchMedia(MOBILE_MQ);
      function sync() { mql.matches ? start() : stop(); }
      sync();

      if (typeof mql.addEventListener === 'function') {
        mql.addEventListener('change', sync);
      } else if (typeof mql.addListener === 'function') {
        mql.addListener(sync); // Safari <14
      }
    }

    function init() {
      var roots = document.querySelectorAll('[data-sro-topbar]');
      for (var i = 0; i < roots.length; i++) initRotator(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Theme-editor hot-reload hooks: re-init when Shopify swaps the
    // section during live editing so the rotator keeps working.
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector('[data-sro-topbar]')) {
        init();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
